import { prefersReducedMotion } from '../shared/browser.js';

const ANIMATE_SELECTOR = '[data-animate]';
const VISIBLE_CLASS = 'is-visible';
const ROW_THRESHOLD = 7;

const getAnimatedElements = () =>
  Array.from(document.querySelectorAll(ANIMATE_SELECTOR));

const groupElementsByParent = (elements) => {
  const groups = new Map();

  elements.forEach((element) => {
    if (!element.parentElement) {
      return;
    }

    if (!groups.has(element.parentElement)) {
      groups.set(element.parentElement, []);
    }

    groups.get(element.parentElement).push(element);
  });

  return groups;
};

const sortElementsByPosition = (elements) => {
  elements.sort((a, b) => {
    const aRect = a.getBoundingClientRect();
    const bRect = b.getBoundingClientRect();

    if (Math.abs(aRect.top - bRect.top) > ROW_THRESHOLD) {
      return aRect.top - bRect.top;
    }

    return aRect.left - bRect.left;
  });
};

const assignGroupIndexes = (group) => {
  let rowTop = null;
  let index = 0;

  group.forEach((element) => {
    const { top } = element.getBoundingClientRect();

    if (rowTop !== null && Math.abs(top - rowTop) > ROW_THRESHOLD) {
      index = 0;
      rowTop = top;
    }

    if (rowTop === null) {
      rowTop = top;
    }

    element.style.setProperty('--animate-index', index);
    index += 1;
  });
};

const assignStaggerIndexes = (elements) => {
  groupElementsByParent(elements).forEach((group) => {
    sortElementsByPosition(group);
    assignGroupIndexes(group);
  });
};

export const initGlobalFadeIn = () => {
  const elements = getAnimatedElements();

  if (!elements.length) {
    return;
  }

  if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
    elements.forEach((element) => element.classList.add(VISIBLE_CLASS));
    return;
  }

  assignStaggerIndexes(elements);

  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      entry.target.classList.add(VISIBLE_CLASS);
      observerInstance.unobserve(entry.target);
    });
  }, {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0,
  });

  elements.forEach((element) => {
    observer.observe(element);
  });
};
